let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eH7OB")).then(() => parcelRequire('74dfH'));